export default {
  baseOption: {
      title : {
          text: '成交数量',
          subtext: '数据来自网络'
          //x:'left'
      },
      tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
          data:['rose1','rose2','rose3','rose4','rose5','rose6','rose7','rose8']
      },
      toolbox: {
          show : true,
          feature : {
              mark : {show: true},
              dataView : {show: true, readOnly: false},
              magicType : {
                  show: true,
                  type: ['pie', 'funnel']
              },
              restore : {show: true},
              saveAsImage : {show: true}
          }
      },
      calculable : true,
      series : [
          {
              name:'半径模式',
              type:'pie',
              roseType : 'radius',
              label: {
                  normal: {
                      show: true
                  },
                  emphasis: {
                      show: true
                  }
              },
              lableLine: {
                  normal: {
                      show: true
                  },
                  emphasis: {
                      show: true
                  }
              },
              data:[
                  {value:10, name:'rose1'},
                  {value:5, name:'rose2'},
                  {value:15, name:'rose3'},
                  {value:25, name:'rose4'},
                  {value:20, name:'rose5'},
                  {value:35, name:'rose6'},
                  {value:30, name:'rose7'},
                  {value:40, name:'rose8'}
              ]
          },
          {
              name:'面积模式',
              type:'pie',
              roseType : 'area',
              data:[
                  {value:10, name:'rose1'},
                  {value:5, name:'rose2'},
                  {value:15, name:'rose3'},
                  {value:25, name:'rose4'},
                  {value:20, name:'rose5'},
                  {value:35, name:'rose6'},
                  {value:30, name:'rose7'},
                  {value:40, name:'rose8'}
              ]
          }
      ]
  },
  media: [
    {
        option: {
            legend: {
                right: 'center',
                // bottom: '5%',
                // orient: 'horizontal'
                orient: 'horizontal'
            },
            series: [
                {
                    radius: ['10%', '30%'],
                    center: ['50%', '30%']
                },
                {
                    radius: ['10%', '30%'],
                    center: ['50%', '65%']
                }
            ]
        }
    }

  ]

}



// WEBPACK FOOTER //
// ./src/data/pie.js